import React, { Component } from 'react';
import { connect } from 'react-redux';

class Nombres extends Component {
    render() {
        const { unites, visibilityNumbers } = this.props;
        const intervalle = 2800 / unites;
        return (
            <g>
                {Array(unites + 1)
                    .fill('')
                    .map((v, u) => (visibilityNumbers || u === 0 || u === unites) && (
                        <text
                            key={u}
                            textAnchor="middle"
                            fontFamily="roboto"
                            fontSize="50"
                            x={100 + u * intervalle}
                            y="100"
                            strokeWidth="0"
                            stroke="#000000"
                            fill="#000000"
                        >
                            {u}
                        </text>
                    ))}
            </g>
        );
    }
}

const mapStateToProps = ({ unites, visibilityNumbers }) => ({ unites, visibilityNumbers });

export default connect(mapStateToProps)(Nombres);
